//TODO : Refactor after ai
/** Kleine UI-Bausteine der App v2 – Stile in theme.css. */
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { zustandFarbe } from "./lib";

export function Seite({
  titel,
  untertitel,
  aktionen,
  children,
}: {
  titel: string;
  untertitel?: ReactNode;
  aktionen?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: 12,
          marginBottom: 20,
          flexWrap: "wrap",
        }}
      >
        <div style={{ flex: 1, minWidth: 200 }}>
          <h1>{titel}</h1>
          {untertitel && (
            <div style={{ color: "var(--vc-muted)", fontSize: "0.85rem" }}>
              {untertitel}
            </div>
          )}
        </div>
        {aktionen && (
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {aktionen}
          </div>
        )}
      </div>
      {children}
    </div>
  );
}

export function Karte({
  titel,
  sub,
  rechts,
  children,
  style,
}: {
  titel?: ReactNode;
  sub?: ReactNode;
  rechts?: ReactNode;
  children: ReactNode;
  style?: React.CSSProperties;
}) {
  return (
    <section className="vc-card" style={style}>
      {(titel || rechts) && (
        <div className="head">
          <div>
            {titel && <h2>{titel}</h2>}
            {sub && <div className="sub">{sub}</div>}
          </div>
          {rechts}
        </div>
      )}
      {children}
    </section>
  );
}

export function Kennzahl({
  label,
  wert,
  hint,
  ton,
}: {
  label: string;
  wert: ReactNode;
  hint?: ReactNode;
  ton?: "warn" | "accent";
}) {
  return (
    <div className={`vc-kpi ${ton ?? ""}`}>
      <div className="label">{label}</div>
      <div className="value">{wert}</div>
      {hint && <div className="hint">{hint}</div>}
    </div>
  );
}

export function Pille({
  status,
  farbe,
  children,
}: {
  status?: string | null;
  farbe?: string;
  children?: ReactNode;
}) {
  const f = farbe ?? zustandFarbe(status);
  return <span className={`vc-pill ${f}`}>{children ?? status ?? "—"}</span>;
}

export function Knopf({
  children,
  onClick,
  art,
  gross,
  disabled,
  type,
}: {
  children: ReactNode;
  onClick?: () => void;
  art?: "primary" | "ghost";
  gross?: boolean;
  disabled?: boolean;
  type?: "button" | "submit";
}) {
  return (
    <button
      type={type ?? "button"}
      className={`vc-btn ${art ?? ""} ${gross ? "big" : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

export function Zeile({
  titel,
  meta,
  rechts,
  zu,
  onClick,
}: {
  titel: ReactNode;
  meta?: ReactNode;
  rechts?: ReactNode;
  zu?: string;
  onClick?: () => void;
}) {
  const nav = useNavigate();
  const klick = onClick ?? (zu ? () => nav(zu) : undefined);
  return (
    <div className={`vc-row ${klick ? "link" : ""}`} onClick={klick}>
      <div className="grow">
        <div className="title">{titel}</div>
        {meta && <div className="meta">{meta}</div>}
      </div>
      {rechts}
    </div>
  );
}

export function Feld({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="vc-field">
      <label>{label}</label>
      {children}
    </div>
  );
}

export function Schritte({ anzahl, aktiv }: { anzahl: number; aktiv: number }) {
  return (
    <div className="vc-steps">
      {Array.from({ length: anzahl }, (_, i) => (
        <span
          key={i}
          className={i < aktiv ? "done" : i === aktiv ? "now" : ""}
        />
      ))}
    </div>
  );
}

export function Hinweis({
  ton,
  children,
}: {
  ton?: "red" | "green";
  children: ReactNode;
}) {
  return <div className={`vc-alert ${ton ?? ""}`}>{children}</div>;
}

export function Beispiel() {
  return (
    <span className="vc-pill" title="Beispielwert, von Viacid zu bestätigen">
      Beispiel
    </span>
  );
}
